import { BusMessage, MessageFactory, calcStringByteLength } from "flavr-common";
/**
 * Forces a module to activate.
 *
 * Note: A module has to listen for this message and implement some behaviour. So this might
 * only work for a few modules. Check first if a module supports this message or implement respective message handlers.
 * A module always has to implement both ActivateModuleMessage and DeactivateModuleMessage.
 */
export class ActivateModuleMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.moduleName);
    }
    constructor(moduleName) {
        super();
        this.moduleName = moduleName;
    }
    serialization(stream) {
        this.moduleName = stream.utf16String(this.moduleName);
    }
    static is(msg) {
        return msg.type === ActivateModuleMessage.typestatic;
    }
}
ActivateModuleMessage.typestatic = "ActivateModuleMessage";
ActivateModuleMessage.subjectstatic = "general";
MessageFactory.register(ActivateModuleMessage);
/**
 * Forces a module to deactivate.
 *
 * Note: A module has to listen for this message and implement some behaviour. So this might
 * only work for a few modules. Check first if a module supports this message or implement respective message handlers.
 * A module always has to implement both ActivateModuleMessage and DeactivateModuleMessage.
 */
export class DeactivateModuleMessage extends BusMessage {
    get byteLength() {
        return calcStringByteLength(this.moduleName);
    }
    constructor(moduleName) {
        super();
        this.moduleName = moduleName;
    }
    serialization(stream) {
        this.moduleName = stream.utf16String(this.moduleName);
    }
    static is(msg) {
        return msg.type === DeactivateModuleMessage.typestatic;
    }
}
DeactivateModuleMessage.typestatic = "DeactivateModuleMessage";
DeactivateModuleMessage.subjectstatic = "general";
MessageFactory.register(DeactivateModuleMessage);
